import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles/Auth.css";
import { API_BASE } from "./config";

export default function ResetPassword() {
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email || "";

  const [code, setCode] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setMsg("");
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          code,
          new_password: password,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        const message =
          data?.msg ||
          data?.message ||
          "Erreur réinitialisation mot de passe";
      
        setError(message);
        setLoading(false);
        return;
      }
      

      setMsg(data.msg || "Mot de passe réinitialisé avec succès");

      setTimeout(() => navigate("/login"), 1500);
    } catch {
      setError("Impossible de contacter le serveur");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="authApp">
      <div className="authCard">
        <h2>Réinitialiser le mot de passe</h2>

        {error && (
        <div className="authError">
          {typeof error === "string" ? error : error.msg || "Erreur"}
        </div>
        )}
        {msg && <div className="authSuccess">{msg}</div>}   

        <form onSubmit={submit}>
          <input
            className="authInput"
            placeholder="Code reçu par email"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />

          <input
            className="authInput"
            type="password"
            placeholder="Nouveau mot de passe"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <div className="authButtons">
            <button className="authBtn authBtnPrimary" type="submit" disabled={loading}>
              {loading ? "Validation..." : "Valider"}
            </button>
            <button
              className="authBtn authBtnSecondary"
              type="button"
              onClick={() => navigate("/forgot-password")}
              disabled={loading}
            >
              Revenir
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
